import { PageHead } from "@/components/PageHead";
import { CollectionHero, HubTiles } from "@/components/CollectionHero";
import { PurchaseSteps } from "@/components/PurchaseSteps";
import { TIMBER_HUB } from "@/lib/timber";

export default function TimberHub() {
  return (
    <div data-testid="timber-hub">
      <CollectionHero
        crumbs={[
          { label: "Our Collection", to: "/collection" },
          { label: "Timber Collection" },
        ]}
        eyebrow={TIMBER_HUB.eyebrow}
        title={TIMBER_HUB.title}
        intro={TIMBER_HUB.intro}
        hero={TIMBER_HUB.hero}
      />
      <HubTiles items={TIMBER_HUB.categories} columns="md:grid-cols-3" />
      <PurchaseSteps />
    </div>
  );
}
